import './index.css'
import profile from '../../assets/images/logo1.png'
import { FaLocationDot } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { IoLogoTiktok } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";

export const Profile =()=>{

    return(
        <div className='profile_div'>
            <div className='inner_profile'>
                <img src='https://res.cloudinary.com/dhhtxax50/image/upload/v1737993208/1737992904637_lm0wkj.jpg' alt='profile img' id='profile_img'/>
                <h3>Larrien Saam</h3>
                <p><FaLocationDot style={{marginRight: "10px"}}/>Yaounde, Cameroon</p>
                <p><i className='quote'>Making a way as a software entrepreneur</i></p>
                <div className='socials'>
                    <a href='https://www.linkedin.com/in/nya-ah-larrien-443423226?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'> <FaLinkedin className="icon"/></a>
                    <a href='https://www.instagram.com/unfoldix?igsh=YzljYTk1ODg3Zg=='><FaInstagram className="icon"/></a>
                    <a href='https://www.tiktok.com/@larrien_saam?_t=ZM-8tPzOycSyhh&_r=1'><IoLogoTiktok className="icon"/></a>
                    <a href='https://x.com/Larrien_Saam?t=9Y01DuGjEQ-fC5SQvod9ug&s=09'><FaXTwitter className="icon"/></a>
                </div>
            </div>
            
        </div>
    )
}